"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GamesList = void 0;

var _react = _interopRequireDefault(require("react"));

var _Game = require("../../molecules/Game");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Drew Burnett
 */
// Imports
// Games List
var GamesList = function GamesList(_ref) {
  var games = _ref.games,
      limit = _ref.limit;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, games === null || games === void 0 ? void 0 : games.slice(0, limit).map(function (game) {
    return /*#__PURE__*/_react.default.createElement(_Game.Game, {
      game: game,
      key: "gameslist-game-".concat(game.game_id)
    });
  }));
};

exports.GamesList = GamesList;
GamesList.defaultProps = {
  limit: 3
};